import S from 's-js';
import TZDate from 'lib/TZDate';
import { IAjax, Request } from 'lib/Ajax';
import { UserSummary } from 'data/models/UserSummary';
import { Entrypoints } from 'core/app/entrypoints';
import { ReservationsInBatch as ServerReservationsInBatch, ReservationsInBatchOptions } from 'data/models/ReservationsInBatch';
import { ReservationsInBatchCache } from './cache';
import { DateRange } from 'portcall/daterangeselector/model';
import { ReservationsListBase, ReservationsListBaseParams } from 'portcall/reservationslistbase/model';

const batchFilterStorageKey = 'portcall.reservationsinbatch.filter';

export interface ReservationsInBatchParams {
    batchId : number;
    range : DateRange;
    from? : TZDate;
    to? : TZDate;
    filter? : string;
}

export function ReservationsInBatch(
    ajax : IAjax,
    entrypoints : Entrypoints,
    cache : ReservationsInBatchCache,
    user : () => UserSummary | null,
    baseModel : (params : ReservationsListBaseParams<ServerReservationsInBatch, ReservationsInBatchOptions>) => ReservationsListBase<ServerReservationsInBatch>,
    { batchId, range, from, to, filter } : ReservationsInBatchParams
) {
    const showConfirmDeleteBatch = S.data(false),
        base = baseModel({
            cacheCollection: cache.ReservationsInBatches,
            modelKey: ({ FromDate, ToDate }) => ({
                FromDate,
                ToDate,
                BatchId: batchId
            }),
            organizationRef: model => () => model().Organization(),
            url: entrypoints.ReservationsInBatch,
            filterStorageKey: batchFilterStorageKey,
            range,
            allowedRanges: [
                DateRange.AllDates,
                DateRange.ThisMonth,
                DateRange.LastMonth,
                DateRange.ThisYear,
                DateRange.LastYear,
                DateRange.Custom
            ],
            from, to, filter
        }),
        deletingBatch = S.data(false);

    return Object.assign({}, base, {
        BatchId: batchId,
        Batch: () => base.Model().Batch(),
        ShowConfirmDeleteBatch: showConfirmDeleteBatch,
        ConfirmDeleteBatch,
        DeleteBatch,
        DeletingBatch: deletingBatch
    });

    function ConfirmDeleteBatch() {
        S.freeze(() => {
            showConfirmDeleteBatch(true);
            base.ShowActionsMenu(false);
        });
    }

    function DeleteBatch() {
        const batch = S.sample(() => base.Model().Batch());
        if (!batch) return;
        deletingBatch(true);
        ajax.Url(() => batch.Url() || '', { useCache: true }).Delete().then(() => {
            showConfirmDeleteBatch(false);
            // need to use a timeout otherwise modal hide animation doesn't finish
            // and semi-transparent modal backdrop is stuck on screen
            setTimeout(() => {
                window.history.back();
            }, 200);
        }).finally(() => deletingBatch(false));
    }
}
export type ReservationsInBatch = ReturnType<typeof ReservationsInBatch>;


// WEBPACK FOOTER //
// ./apps/portcall/reservationsinbatch/model.ts